// Shared API helper. Uses the CRA proxy in development and the same-origin
// API in production; attaches the JWT from the stored user automatically.
import { getValidStoredUser } from '../config/session';

const API_BASE = process.env.REACT_APP_API_URL || 'https://quibly.onrender.com';

export const apiFetch = async (path, { method = 'GET', body, formData } = {}) => {
  const user = getValidStoredUser();

  const headers = {};
  if (!formData) headers['Content-Type'] = 'application/json';
  if (user && user.token) {
    headers['Authorization'] = `Bearer ${user.token}`;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: formData || (body !== undefined ? JSON.stringify(body) : undefined)
  });

  let json = null;
  try {
    json = await response.json();
  } catch (e) {
    // non-JSON response
  }

  if (!response.ok) {
    const error = new Error((json && json.error) || `Request failed (${response.status})`);
    error.status = response.status;
    error.data = json;
    throw error;
  }
  return json;
};
